import AdminNav from "../../components/AdminNav";
import Collapsible from "../../components/Collapsible";

export default function AdminGuide() {
  return (
    <div className="admin-app">
      <AdminNav />
      <div className="page wide page-with-nav">
        <div className="brand-header">
          <span className="brand-logo">📖</span>
          <span className="brand-name">Admin Guide</span>
          <p className="brand-tagline">A quick reference for running the platform day-to-day</p>
        </div>

        <Collapsible title="🛵 Fleet — Rider Approval" defaultOpen className="delivery-card">
          <p className="hint" style={{ marginBottom: "8px" }}>
            Review pending dispatcher registrations, their KYC details, and verification documents.
            Approve, reject, or block riders here, and adjust priority status. Profile change requests
            (a rider updating their KYC after approval) show up in their own tab for review.
          </p>
        </Collapsible>

        <Collapsible title="👥 Users — Business Accounts" className="delivery-card">
          <p className="hint" style={{ marginBottom: "8px" }}>
            Manage customer accounts (block/unblock) and the four business tiers. Agent and Fleet
            Owner are simple one-click approve/revoke. B2B/Partner and Corporate are two{" "}
            <strong>independent</strong> tracks — a company can hold either, both, or neither, each
            approved on its own timeline:
          </p>
          <ul style={{ paddingLeft: "18px", fontSize: "14px", color: "var(--text-secondary)", lineHeight: 1.7 }}>
            <li><strong>🔑 Approve B2B Access</strong> — issues an API key for programmatic integration. Revoking it never touches Corporate status.</li>
            <li><strong>🏛️ Approve Corporate Access</strong> — unlocks their in-app booking dashboard and consolidated invoicing. Revoking it never touches B2B status.</li>
            <li>The "Business Requests" tab surfaces pending applications for either track.</li>
            <li>For invoiced accounts, toggle between <strong>Pay Now</strong> and <strong>Consolidated</strong> billing, and review their invoices from the same card.</li>
          </ul>
        </Collapsible>

        <Collapsible title="📦 Orders" className="delivery-card">
          <p className="hint">
            Monitor active/all orders by city and status, manually reassign a stuck order to a
            different rider, and set a price for truck jobs (which are quoted on request rather than
            auto-priced) — if left unpriced for 10 minutes, the system applies an inflated placeholder
            quote automatically so the job doesn't sit invisible.
          </p>
        </Collapsible>

        <Collapsible title="🚨 Issues, Claims & Support" className="delivery-card">
          <p className="hint">
            <strong>Issues</strong> are problems riders raise on a specific order. <strong>Claims</strong>{" "}
            track loss/damage disputes through review to resolution. <strong>Support</strong> holds
            general tickets from any user. Verification overrides (when a receiver genuinely can't
            produce their PIN) also need a decision here before a rider can mark that order delivered.
          </p>
        </Collapsible>

        <Collapsible title="💰 Revenue & Pricing" className="delivery-card">
          <p className="hint" style={{ marginBottom: "8px" }}>
            The Revenue dashboard shows platform commission across digital and cash orders, plus total
            B2B/Corporate outstanding balance broken down per business.
          </p>
          <p className="hint">
            Pricing lets you tune base fare, per-km rate, commission percent, weight/vehicle modifiers,
            surge, and the truck auto-quote multiplier — every change is logged in Pricing History.
          </p>
        </Collapsible>

        <Collapsible title="🔑 Admins" className="delivery-card">
          <p className="hint">Create or remove other admin accounts here.</p>
        </Collapsible>
      </div>
    </div>
  );
}
